<template>
  <Modal
    class="vote-history"
    v-if="modals.voteHistory && (session.voteHistory || !session.isSpectator)"
    @close="toggleModal('voteHistory')"
  >
    <font-awesome-icon
      @click="clearVoteHistory"
      icon="trash-alt"
      class="clear"
      :title="$t('voting.clearVoteHistory')"
      v-if="session.isSpectator"
    />

    <h3>{{ $t("voting.voteHistory") }}</h3>

    <template v-if="!session.isSpectator">
      <div class="options">
        <div class="option" @click="setRecordVoteHistory">
          <font-awesome-icon
            :icon="[
              'fas',
              session.isVoteHistoryAllowed ? 'check-square' : 'square',
            ]"
          />
          {{ $t("voting.accessibleToPlayers") }}
        </div>
        <div class="option" @click="clearVoteHistory">
          <font-awesome-icon icon="trash-alt" />
          {{ $t("voting.clearForEveryone") }}
        </div>
      </div>
    </template>
    <table>
      <thead>
        <tr>
          <td>{{ $t("voting.time") }}</td>
          <td>{{ $t("voting.nominator") }}</td>
          <td>{{ $t("voting.nominee") }}</td>
          <td>{{ $t("voting.type") }}</td>
          <td>{{ $t("voting.votes") }}</td>
          <td>{{ $t("voting.majority") }}</td>
          <td>
            <font-awesome-icon icon="user-friends" />
            {{ $t("voting.voters") }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(vote, index) in session.voteHistory" :key="index">
          <td>
            {{ vote.timestamp.getHours().toString().padStart(2, "0") }}:{{
              vote.timestamp.getMinutes().toString().padStart(2, "0")
            }}
          </td>
          <td>{{ getPlayerDisplay(vote.nominatorIndex, vote.nominator) }}</td>
          <td>{{ getPlayerDisplay(vote.nomineeIndex, vote.nominee) }}</td>
          <td>{{ vote.type }}</td>
          <td>
            {{ vote.votes.length }}
            <font-awesome-icon icon="hand-paper" />
          </td>
          <td>
            {{ vote.majority }}
            <font-awesome-icon
              :icon="[
                'fas',
                vote.votes.length >= vote.majority ? 'check-square' : 'square',
              ]"
            />
          </td>
          <td>
            {{ getVotersDisplay(vote.votes) }}
          </td>
        </tr>
      </tbody>
    </table>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    Modal,
  },
  computed: {
    ...mapState(["session", "modals"]),
  },
  methods: {
    getPlayerDisplay(index, name) {
      const seatNumber = index + 1;
      const displayName =
        name === "__EMPTY_SEAT__" ? this.$t("player.emptySeatName") : name;
      return `${seatNumber}. ${displayName}`;
    },
    getVotersDisplay(votes) {
      if (
        Array.isArray(votes) &&
        votes.length > 0 &&
        typeof votes[0] === "object"
      ) {
        // New format with index and name
        return votes
          .map((vote) => {
            const seatNumber = vote.index + 1;
            const displayName =
              vote.name === "__EMPTY_SEAT__"
                ? this.$t("player.emptySeatName")
                : vote.name;
            return `${seatNumber}. ${displayName}`;
          })
          .join(", ");
      } else {
        // Old format with just names (for backward compatibility)
        return votes
          .map((name) => {
            return name === "__EMPTY_SEAT__"
              ? this.$t("player.emptySeatName")
              : name;
          })
          .join(", ");
      }
    },
    clearVoteHistory() {
      this.$store.commit("session/clearVoteHistory");
    },
    setRecordVoteHistory() {
      this.$store.commit(
        "session/setVoteHistoryAllowed",
        !this.session.isVoteHistoryAllowed,
      );
    },
    ...mapMutations(["toggleModal"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../vars.scss";

.clear {
  position: absolute;
  left: 20px;
  top: 15px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

.options {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.option {
  color: white;
  text-decoration: none;
  margin: 0 15px;
  &:hover {
    color: red;
    cursor: pointer;
  }
}

h3 {
  margin: 0 40px 0 10px;
  svg {
    vertical-align: middle;
  }
}

table {
  border-spacing: 10px 0;
  margin-left: auto;
  margin-right: auto;
}

thead td {
  font-weight: bold;
  border-bottom: 1px solid white;
  text-align: center;
  padding: 0 3px;
}

tbody {
  td:nth-child(2) {
    color: $townsfolk;
  }
  td:nth-child(3) {
    color: $demon;
  }
  td:nth-child(5) {
    text-align: center;
  }
  td:nth-child(6) {
    text-align: center;
  }
}
</style>
